import BrandLockup from "./BrandLockup"
import BrandPanel from "./BrandPanel"

const PRIVACY_URL = "https://theurbanwriters.com/pages/privacy-policy"
const TERMS_URL = "https://theurbanwriters.com/pages/terms-of-service"

// The split auth layout (design/spec/auth/auth.html): a form column with the
// lockup header, a centred 400px form and a legal footer, beside the dark
// brand panel. The panel drops below 980px and the column tightens below
// 560px. Rendered on the clean-slate Inertia layout, never inside AppShell:
// the visitor is not signed in.
export default function AuthLayout({ panel = "signin", swap, children }) {
  return (
    <div className="grid min-h-screen grid-cols-[minmax(0,1fr)_minmax(0,1fr)] bg-background text-foreground max-[980px]:grid-cols-1">
      <div className="flex min-w-0 flex-col px-10 py-[30px] max-[980px]:px-6 max-[980px]:py-[22px] max-[560px]:px-[18px] max-[560px]:pt-[18px]">
        <header className="flex items-center justify-between gap-3">
          <a href="/users/sign_in" className="shrink-0">
            <BrandLockup className="h-[30px] max-[560px]:h-6" />
          </a>
          {swap && (
            <div className="text-[13px] font-semibold text-muted-foreground">
              <span className="max-[560px]:hidden">{swap.prompt} </span>
              <a
                href={swap.href}
                className="text-foreground underline decoration-line-2 underline-offset-[3px] hover:decoration-foreground"
              >
                {swap.label}
              </a>
            </div>
          )}
        </header>

        <main className="flex flex-1 items-center justify-center py-9 max-[560px]:items-start max-[560px]:py-[30px]">
          <div className="flex w-full max-w-[400px] flex-col gap-[22px]">{children}</div>
        </main>

        <footer className="flex flex-wrap justify-between gap-3 text-[12px] text-ink-3 [&_a]:text-muted-foreground [&_a:hover]:text-foreground">
          <span>© {new Date().getFullYear()} Dibbly Inc.</span>
          <span>
            <a href="mailto:support@dibbly.com">Help</a> · <a href={PRIVACY_URL}>Privacy</a> ·{" "}
            <a href={TERMS_URL}>Terms</a>
          </span>
        </footer>
      </div>

      <BrandPanel variant={panel} />
    </div>
  )
}
